import { client } from '../http';

export default {
  async createBenefitByPromoCode(promoCode) {
    const response = await client.post('/api/partial-auth/benefits/promo-code', { promoCode });
    return response.data;
  },

  async getActiveBenefit() {
    const response = await client.get('/api/benefits/active');
    return response.data;
  },

  async redeemBenefit(benefitId) {
    const response = await client.put(`/api/benefits/redeem/${benefitId}`);
    return response.data;
  },

  async hasHeverBenefit() {
    const response = await client.get('/api/benefits/has-hever-benefit');
    return response.data;
  },

  async isEligibleForPromoCode(promoCode) {
    const response = await client.get(`/api/benefits/is-eligible/${promoCode}`);
    return response.data;
  },
};
